import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/emr-health-check-campaign";


export const addHealthCheckCampaignManage= (data) => axios.post(API_PATH + "/save-or-update" ,data);
export const getByIdHealthCheckCampaignManage = (id) => axios.get(API_PATH + "/get-by-id/" +id);
export const pagingHealthCheckCampaignManage = (obj) => axios.post(API_PATH + "/search-by-page", obj);
export const markDeleteHealthCheckCampaignManage = (id) => axios.delete(API_PATH + "/mark-delete/" + id)
export const synDeleteHealthCheckCampaignManage = (obj) => axios.post(API_PATH + "/syn-health-check-campaign",obj)

